module.exports = __webpack_public_path__ + "img/user-card.a17b081a.svg";